import { Link } from "@tanstack/react-router";
import { Instagram, Phone } from "lucide-react";
import { contactInfo, socials } from "../lib/data";

/**
 * Vaste actiebalk onderaan het scherm op mobiel (< md): altijd één tik
 * verwijderd van bellen, Instagram of een offerte-aanvraag. De WhatsApp-bubbel
 * zweeft er net boven (zie WhatsAppButton). Alleen zichtbaar op kleine schermen.
 */
export function MobileActionBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-border/60 bg-background/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden">
      <div className="grid grid-cols-[auto_1fr_1fr] gap-2 px-4 py-3">
        <a
          href={socials.instagram.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Fedor Timmerwerken op Instagram (${socials.instagram.handle})`}
          className="inline-flex h-12 w-12 items-center justify-center rounded-md border border-input bg-background text-foreground transition-colors hover:bg-secondary"
        >
          <Instagram className="h-5 w-5" aria-hidden="true" />
        </a>
        <a
          href={contactInfo.telefoonHref}
          className="inline-flex h-12 items-center justify-center gap-2 rounded-md border border-input bg-background font-heading text-sm font-semibold text-foreground transition-colors hover:bg-secondary"
        >
          <Phone className="h-4 w-4" aria-hidden="true" />
          Bellen
        </a>
        <Link
          to="/contact"
          className="inline-flex h-12 items-center justify-center rounded-md bg-primary px-2 font-heading text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Offerte
        </Link>
      </div>
    </div>
  );
}

